import React from 'react';
import { Link } from 'react-router-dom';
import { brandContent } from '../data/mock';
import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer
      className="py-10 sm:py-12 md:py-16 relative overflow-hidden bg-primary-navy"
    >
      {/* Subtle gradient accent at top */}
      <div
        className="absolute top-0 left-0 right-0 h-1 bg-[linear-gradient(90deg,transparent_0%,theme(colors.brand-gradient.gold.end)_20%,#D4AF37_50%,theme(colors.brand-gradient.gold.end)_80%,transparent_100%)]"
      />

      <div className="max-w-6xl mx-auto px-6 md:px-12">


        {/* Middle Row - Brand & Contact */}
        <div className="flex flex-col items-center gap-4 mb-8">


          <div className="flex items-center gap-6">
            <a
              href={`mailto:${brandContent.contact.email}`}
              className="transition-opacity duration-300 hover:opacity-80"
            >
              <span className="font-body text-sm tracking-wide text-primary-beige">
                {brandContent.contact.email}
              </span>
            </a>

            <div className="w-px h-3 bg-primary-beige opacity-30"></div>

            <a
              href="https://instagram.com/zurian.co.in"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:scale-110 hover:opacity-80 text-primary-beige"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Made With Section */}
        <div className="text-center mb-6">
          <p className="font-body text-sm sm:text-base flex items-center justify-center gap-2 text-secondary-steel-blue">
            Made with Expertise and{' '}
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="inline-block text-brand-gradient-gold-end"
              style={{ width: '1em', height: '1em', verticalAlign: '-0.15em' }}
            >
              <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
            </svg>
            {' '}in Jaipur
          </p>
        </div>

        {/* Bottom Row - Copyright */}
        <div className="flex flex-col items-center gap-4 pt-2">
          {/* New Tagline */}
          <p className="font-heading text-xl sm:text-2xl text-brand-gradient-gold-end font-medium px-4 text-center tracking-wide">
            Once a ZURIAN, is always a ZURIAN.
          </p>

          <div className="flex flex-col items-center gap-1 text-center mt-2">

            <p className="font-body text-[9px] sm:text-[10px] md:text-xs opacity-60 text-primary-beige">
              ZURIAN&trade;
            </p>
            <div
              className="font-body text-[9px] sm:text-[10px] md:text-xs opacity-40 uppercase tracking-wider flex flex-wrap items-center justify-center gap-1.5 sm:gap-2 text-primary-beige"
            >
              <span>© 2026 Zurian International Pvt. Ltd.</span>
              <span>|</span>
              <Link to="/privacy-policy" className="hover:underline hover:opacity-100 transition-opacity">Privacy Policy</Link>
              <span>|</span>
              <Link to="/terms-of-service" className="hover:underline hover:opacity-100 transition-opacity">Terms</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
